export const LOG_TABLE_CLASS = "w-full text-left border-collapse text-xs";
export const LOG_TABLE_HEAD_CLASS = "sticky top-0 z-10";
export const LOG_TABLE_ROW_CLASS = "border-b border-border";
export const LOG_TABLE_HEADER_CELL_CLASS =
  "px-3 py-2.5 font-semibold text-text-muted uppercase tracking-wider text-[10px]";
export const LOG_TABLE_HEADER_CELL_RIGHT_CLASS = `${LOG_TABLE_HEADER_CELL_CLASS} text-right`;
export const LOG_TABLE_HEADER_BG_STYLE = { backgroundColor: "var(--color-bg, #fff)" } as const;
